import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.78033 5.03033C10.0732 4.73744 10.0732 4.26256 9.78033 3.96967C9.48744 3.67678 9.01256 3.67678 8.71967 3.96967L2.46967 10.2197C2.17678 10.5126 2.17678 10.9874 2.46967 11.2803L8.71967 17.5303C9.01256 17.8232 9.48744 17.8232 9.78033 17.5303C10.0732 17.2374 10.0732 16.7626 9.78033 16.4697L4.81066 11.5H16.25C18.0455 11.5 19.5 12.9534 19.5 14.7478V19.25C19.5 19.6642 19.8358 20 20.25 20C20.6642 20 21 19.6642 21 19.25V14.7478C21 12.1239 18.8728 10 16.25 10H4.81066L9.78033 5.03033Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgReply;
